import template from './leave_cost_per_department_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveCostPerDepartmentHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveCostPerDepartmentHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveCostPerDepartmentHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveCostPerDepartmentHelp',
	dialog_class: LeaveCostPerDepartmentHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_cost_per_department_help',
	provider: 'ps'
};
